const BASE_URL = process.env.REACT_APP_API;
const BASE_OAUTH = process.env.REACT_APP_OAUTH;
const CLIENT_ID = process.env.REACT_APP_CLIENT;
const LOCAL_URL = process.env.REACT_APP_LOCAL;
const USERS_URL = process.env.REACT_APP_USERS;
const DOCS_URL = process.env.REACT_APP_DOCS;
const POLICY_URL = process.env.REACT_APP_POLICY;
const ACCOUNTANT_URL = process.env.REACT_APP_ACCOUNTANT;
const REASEGURO_URL = process.env.REACT_APP_REASEGURO;
const WORKFLOW_URL = process.env.REACT_APP_WORKFLOW;
const ANALYST_URL = process.env.REACT_APP_ANALYST;
const SINIESTROS_URL = process.env.REACT_APP_SINIESTROS;
const SEARCH_DELAY_MS = process.env.REACT_APP_SEARCH_DELAY_MS;
const ORSAN_LOGO_URL = "https://pub-3ff0bf4b9e934ca3ae258ae98e7eefd1.r2.dev/logo-orsan-seguros-azul-corto.png";

const DEFAULT_PAGE_SIZE = 20;
export const calculatePages = (rows) => Math.ceil(rows / DEFAULT_PAGE_SIZE);

const API = {
  login: 'authorize',
  endSession: 'end-session',
  userinfo: 'userinfo',
  clientes: 'clientes/',
  proyectos: 'proyecto_garantia/',
  movimientos: 'movimientos_linea/',
  movimientosGrupo: 'movimientos_linea_grupo/',
  lineasGarantia: 'lineas_garantia/',
  lineasGarantiaGrupo: 'lineas_garantia_grupo/',
  regiones: 'regiones/',
  comunas: 'comunas/',
  upload: 'upload',
  download: 'download',
  tieneMovimientos: 'tiene_movimientos_linea',
  oportunidadesLinea: 'oportunidades_garantia/',
  estadosOportunidad: 'estados_oportunidad/',
  observacionesOportunidad: 'observaciones_oportunidad/',
  suscriptores: 'suscriptores/',
  antecedentes: 'antecedentes_oportunidad/',
  motivosRechazo: 'motivos_rechazo_oportunidad/',
  facturacion: 'tipo_facturacion/',
  tipoCobranza: 'tipo_cobranza/',
  formaPoliza: 'forma_poliza/',
  estado_proyecto: 'estado_proyecto/',
  tipoIntermediario: 'tipo-intermediario/',
  grupos_economicos: 'grupos_economicos/',
};

const ROLES = {
  intermediarioGarantia: 'intermediariogarantia',
  afianzadoVentaVerde: 'afianzadoventaenverde',
};

const ESTADO_PROYECTO = {
  activo: 'activo',
  caducado: 'caducado',
  borrador: 'borrador',
};

const PROFILES = {
  ceo: 'ceo',
  administradorTI: 'administrador-ti',
  consultaBasico: 'consulta-basico',
  comercialGarantia: 'comercial-garantia',
  suscripcionGarantia: 'suscripcion-garantia',
  analistaRiesgoGarantia: 'analista-riesgo-garantia',
  gerenteRiesgoGarantia: 'gerente-riesgo-garantia',
  comercialCredito: 'comercial-credito',
  riesgoCredito: 'riesgo-credito',
  fiscalia: 'fiscalia',
  actuariado: 'actuariado',
  gerenteOperaciones: 'gerente-operaciones',
  analistaOperaciones: 'analista-operaciones',
  riesgoOperacional: 'riesgo-operacional',
  siniestros: 'siniestros',
  recuperoSiniestros: 'recupero-siniestros',
  administrador: 'administrador',
  consultaEspecial: 'consulta-especial',
  gerenteGarantia: 'gerente-garantia',
};

export const ADMIN_ROLES = [PROFILES.ceo, PROFILES.administradorTI];

const EXPOSICION_MAXIMA_PERMITIDA = 500000;

const FRONT_DF_1 = 'DD-MM-YYYY';
const BACKEND_DF = 'YYYY-MM-DD';

const TIPO_INTERMEDIARIO_DIRECTO_ID = 1;

export {
  ACCOUNTANT_URL,
  API,
  BASE_URL,
  BASE_OAUTH,
  CLIENT_ID,
  EXPOSICION_MAXIMA_PERMITIDA,
  LOCAL_URL,
  DOCS_URL,
  POLICY_URL,
  PROFILES,
  SEARCH_DELAY_MS,
  USERS_URL,
  WORKFLOW_URL,
  ANALYST_URL,
  REASEGURO_URL,
  SINIESTROS_URL,
  FRONT_DF_1,
  BACKEND_DF,
  DEFAULT_PAGE_SIZE,
  ROLES,
  ESTADO_PROYECTO,
  TIPO_INTERMEDIARIO_DIRECTO_ID,
  ORSAN_LOGO_URL
};

export const ESTADOS_OPORTUNIDAD = {
  creado: 'creado',
  suscriptorAsignado: 'suscriptor-asignado',
  informacionInicialCargada: 'informacion-inicial-cargada',
  informacionInicialValidada: 'informacion-inicial-validada',
  informacionCompletadaEsperandoSuscriptor: 'informacion-completada-esperando-suscriptor',
  informacionCompletadaEsperandoRiesgo: 'informacion-completada-esperando-riesgo',
  informacionCompletadaEsperandoComite: 'informacion-completada-esperando-comite',
  evaluacionAprobada: 'evaluacion-aprobada',
  rechazado: 'rechazado',
  exposicionMaximaHabilitada: 'exposicion-maxima-habilitada',
  contrafianzaCargada: 'contrafianza-cargada',
  emitida: 'emitida',
};

export const OPORTUNIDADES_STATE_SECTION_MAP = {
  creado: 1,
  'suscriptor-asignado': 2,
  'informacion-inicial-cargada': 3,
  'informacion-inicial-validada': 4,
  'informacion-completada-esperando-suscriptor': 5,
  'informacion-completada-esperando-riesgo': 6,
  'informacion-completada-esperando-comite': 7,
  'evaluacion-aprobada': 8,
  rechazado: 9,
  'exposicion-maxima-habilitada': 10,
  'contrafianza-cargada': 11,
  emitida: 12,
};
